import { compose } from 'redux'

// higher-order components
import withQueryResults from 'components/shared/withQueryResults'
import withPathname from 'components/shared/withPathname'
import withRedux from './withRedux'
import withRedirects from './withRedirects'
import withQuery from './withQuery'
import withFormResets from './withFormResets'
import withEntityDelete from './withEntityDelete'

// presentational components
import UI from './UI'

const withAccountOverview = compose(
  withPathname, // for navigation UI
  withRedux, // for setting error state
  withQueryResults, // for handling query errors
  withQuery, // for fetching account data
  withRedirects, // for redirecting from empty lists to "new" forms in reg flow
  withFormResets, // for clearing forms for child pages
  withEntityDelete // for setting which delete modal is to be used
)

export default withAccountOverview(UI)

// for registration flow
export { withAccountOverview }
